import { KendoBaseComponent, KendoBaseDatasourceComponent } from '@progress/kendo-base-components-vue-wrapper'
import AutoCompleteProps from './AutoCompleteProps'

import Animation from '../Common/Animation'
import Virtual from '../Common/Virtual'

export default {
    emits: {
        'update:modelValue': null,
        'kendowidgetready': null
    },
    props: AutoCompleteProps,
    mixins: [
        KendoBaseComponent,
        KendoBaseDatasourceComponent,
        Animation,
        Virtual
    ],
    model:{
        event: 'changemodel'
    },
    mounted() {
        var that = this
        var widgetElement = that.$el
        kendo.jQuery(widgetElement).kendoAutoComplete(that.widgetOptions)
        if(this.v3) {
            this.ready()
            this.$emit('kendowidgetready', this.kendoWidget())
        } else {
            this.$emit('kendowidgetready', this.kendoWidget())
        }

        that.kendoWidget().bind('change', function(){
            if(that.v3){
                that.$emit('update:modelValue', widgetElement.value)
            } else {
                that.$emit('changemodel', widgetElement.value)
            }
        })
    },
    methods: {
        kendoWidget() {
            var widgetElement = this.$el

            return kendo.jQuery(widgetElement).getKendoAutoComplete()
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-dropdowns-vue-wrapper/src/KendoAutoComplete/KendoAutoCompleteMixin.js